module.exports = __webpack_public_path__ + "static/banner5-2080acdcd486a172a87b582ca428e2f4.jpeg";